import * as methods from '../methods';
import { Resource } from '../Resource';
const rootPath = 'tours';
const toRaw = {
    update: (t) => ({
        name: t.name,
        completed_at: t.completedAt,
        canceled_at: t.canceledAt
    })
};
const fromRaw = {
    get: (t) => ({
        name: t.name,
        completedAt: t.completed_at,
        canceledAt: t.canceled_at,
        availabilityDate: t.availability_date
    }),
    getMany: (tours) => tours.map(fromRaw.get)
};
const tours = Resource((requesterBuilder, config) => {
    const host = config.getCtx().hosts.ts;
    const getMany = methods.get({
        requesterBuilder,
        rootPath,
        fromRaw: fromRaw.getMany,
        host
    });
    const update = (tourName) => methods.update({
        method: 'PATCH',
        requesterBuilder,
        rootPath,
        fromRaw: () => undefined,
        parse: async (x) => x,
        toRaw: toRaw.update,
        host
    })(tourName);
    return {
        getMany,
        update
    };
});
export default tours;
